'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash.sortby');

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = require('lodash.deburr');

var _lodash4 = _interopRequireDefault(_lodash3);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ToggleButton = require('./ToggleButton');

var _ToggleButton2 = _interopRequireDefault(_ToggleButton);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ToggleButtons = function (_PureComponent) {
	_inherits(ToggleButtons, _PureComponent);

	function ToggleButtons() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, ToggleButtons);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ToggleButtons.__proto__ || Object.getPrototypeOf(ToggleButtons)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hasBeenFocused: false }, _this.onFocus = function () {
			if (!_this.state.hasBeenFocused) _this.setState({ hasBeenFocused: true });
			_this.setState({ focus: true });
		}, _this.getItemFromValue = function (value) {
			var dataset = _this.props.dataset;


			var ob = dataset.find(function (d) {
				return d.value.toString() === value.toString();
			});
			if (!ob) {
				console.error("[ToggleButtons] Value", value, "not found in dataset"); //eslint-disable-line
				return null;
			}

			return ob;
		}, _this.onChange = function (value) {
			return function () {
				_this.onFocus();
				var _this$props = _this.props,
				    onChange = _this$props.onChange,
				    selected = _this$props.selected;


				if (value === null || value === "") return null;

				var ob = _this.getItemFromValue(value);

				if (!ob) return null;

				// Check if value is already in selected values
				var newSelected = void 0;
				if (selected.indexOf(ob.value) === -1) {
					// Not in selected, we should add it
					newSelected = [].concat(_toConsumableArray(selected), [ob.value]);
				} else {
					// Already in selected, we should remove it
					newSelected = selected.filter(function (s) {
						return s !== ob.value;
					});
				}

				onChange({ item: ob, selected: newSelected, type: 'toggle-buttons' });
			};
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(ToggleButtons, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    required = _props.required,
			    label = _props.label,
			    errorRequiredText = _props.errorRequiredText,
			    className = _props.className,
			    selected = _props.selected,
			    sort = _props.sort,
			    disabled = _props.disabled,
			    dataset = _props.dataset,
			    error = _props.error;
			var hasBeenFocused = this.state.hasBeenFocused;


			var display = sort ? (0, _lodash2.default)(dataset, [function (_ref2) {
				var label = _ref2.label;
				return (0, _lodash4.default)(label);
			}]) : dataset;
			var shouldDisplayError = hasBeenFocused && required && selected.length === 0;

			return _react2.default.createElement(
				'div',
				{ className: (0, _classnames2.default)('bnc_field', 'bnc_field_toggle-buttons', className) },
				label && label !== '' && _react2.default.createElement(
					'span',
					{ className: (0, _classnames2.default)('label', { 'is-error': error || shouldDisplayError }) },
					label,
					required && _react2.default.createElement(
						'abbr',
						null,
						'*'
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'bnc_field_toggle-buttons_items' },
					display.map(function (item) {
						return _react2.default.createElement(_ToggleButton2.default, {
							key: item.value,
							disabled: disabled,
							onToggle: _this2.onChange(item.value),
							active: selected.findIndex(function (s) {
								return s === item.value;
							}) > -1,
							label: item.label
						});
					})
				),
				shouldDisplayError && errorRequiredText !== '' && _react2.default.createElement(
					'span',
					{ className: 'error' },
					errorRequiredText
				)
			);
		}
	}]);

	return ToggleButtons;
}(_react.PureComponent);

ToggleButtons.defaultProps = {
	required: false,
	disabled: false,
	label: '',
	errorRequiredText: '',
	className: '',
	sort: true,
	error: false
};

ToggleButtons.propTypes = {
	selected: _propTypes2.default.arrayOf(_utils.StringOrNumber).isRequired,
	dataset: _propTypes2.default.arrayOf(_propTypes2.default.shape({
		value: _utils.StringOrNumber.isRequired,
		label: _utils.StringOrReact.isRequired
	})).isRequired,
	sort: _propTypes2.default.bool,
	onChange: _propTypes2.default.func,
	label: _utils.StringOrReact,
	required: _propTypes2.default.bool,
	disabled: _propTypes2.default.bool,
	errorRequiredText: _utils.StringOrReact,
	className: _propTypes2.default.string,
	error: _propTypes2.default.bool
};

exports.default = ToggleButtons;